import { Edit, ImageField, ImageInput, NumberInput, SimpleForm, TextInput, BooleanInput, ArrayInput, SimpleFormIterator, DateInput, SelectInput } from 'react-admin';
import { Grid, Typography, Box } from '@mui/material';
import { useWatch } from 'react-hook-form';

const PrizePointsField = () => {
	const prizeType = useWatch({ name: 'type' });

	if (prizeType !== 'נקודות') {
		return null;
	}

	return (
		<Grid item xs={12} sm={6}>
			<NumberInput source="points" label="נקודות" fullWidth />
		</Grid>
	);
};

const CouponSourceField = () => {
	const prizeType = useWatch({ name: 'type' });
	if (prizeType !== 'קופון') return null;
	return (
		<Grid item xs={12} sm={6}>
			<TextInput source="coupon_source_url" label="קישור לאתר של הקופון" fullWidth dir="ltr" />
		</Grid>
	);
};

const LinksFields = () => {
	const prizeType = useWatch({ name: 'type' });
	if (prizeType !== 'לינקים' && prizeType !== 'ספוטיפיי') return null;
	return (
		<>
			<Grid item xs={12} sm={6}>
				<TextInput source="youtube_link" label="לינק יוטיוב" fullWidth dir="ltr" />
			</Grid>
			<Grid item xs={12} sm={6}>
				<TextInput source="spotify_link" label="לינק ספוטיפיי" fullWidth dir="ltr" />
			</Grid>
		</>
	);
};

const AiPrizeEdit = () => {
	return (
		<Edit>
			<SimpleForm width={'100%'}>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<Typography variant="h6">תמונה</Typography>
					</Grid>
					<Grid item xs={12}>
						<ImageField source="image" sx={{ 
							'& image': { 
								maxWidth: '100%', 
								maxHeight: 200, 
								objectFit: 'contain' 
							} 
						}} />
					</Grid>
					<Grid item xs={12}>
						<ImageInput source="image" label="תמונה" accept="image/*">
							<ImageField source="src" />
						</ImageInput>
					</Grid>
					<Grid item xs={12}>
						<Typography variant="h6">כותרת</Typography>
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextInput source="title.he" label="כותרת (עברית)" fullWidth dir="rtl" />
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextInput source="title.en" label="כותרת (אנגלית)" fullWidth dir="ltr" />
					</Grid>
					<Grid item xs={12}>
						<Typography variant="h6">תת כותרת</Typography>
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextInput source="sub_title.he" label="תת כותרת (עברית)" fullWidth dir="rtl" />
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextInput source="sub_title.en" label="תת כותרת (אנגלית)" fullWidth dir="ltr" />
					</Grid>
					<Grid item xs={12}>
						<Typography variant="h6">פרטים</Typography>
					</Grid>
					<Grid item xs={12}>
						<Typography variant="subtitle2" sx={{ mb: 1 }}>קודים</Typography>
						<ArrayInput source="codes" label="קודים" defaultValue={[]}>
							<SimpleFormIterator inline>
								<TextInput source="code" label="קוד" sx={{ width: '30%', mr: 1 }} />
								<TextInput source="is_used" label="שימוש (ID)" sx={{ width: '30%', mr: 1 }} />
								<DateInput source="when_used" label="תאריך שימוש" sx={{ width: '30%' }} />
							</SimpleFormIterator>
						</ArrayInput>
					</Grid>
					<Box width="100%" />
					<PrizePointsField />
					<CouponSourceField />
					<LinksFields />
					<Grid item xs={12} sm={6}>
						<SelectInput
							source="type"
							label="סוג" 
							fullWidth
							choices={[
								{ id: 'קופון', name: 'קופון' },
								{ id: 'נקודות', name: 'נקודות' },
								{ id: 'ספוטיפיי', name: 'ספוטיפיי' },
								{ id: 'לינקים', name: 'לינקים' },
								{ id: 'שיר', name: 'שיר' },
							]}
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<BooleanInput source="active" label="פעיל" />
					</Grid>
				</Grid>
			</SimpleForm>
		</Edit>
	);
};

export default AiPrizeEdit;
